import React from 'react';
import Button from '@material-ui/core/Button';
import { setAuthUser, updateLoadUser } from '../../../redux/actions/Auth';
import { Box } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useDispatch } from 'react-redux';
import GoogleButton from 'react-google-button';
import {
  firestore,
  auth,
  storage,
  facebookAuthProvider,
  githubAuthProvider,
  googleAuthProvider,
  twitterAuthProvider,
  appleAuthProvider,
} from '../../configs/config';
import {  createUserWithEmailAndPassword, onAuthStateChanged, sendPasswordResetEmail, getIdToken, 
  signInWithCustomToken, signInWithEmailAndPassword, signInWithPopup, signOut, updateProfile } from "firebase/auth";
import { collection, doc, updateDoc } from "firebase/firestore"; 

import { fetchError, fetchStart, fetchSuccess } from '../../../redux/actions';
import {
  UpdateLoadSubscription,
} from '../../../redux/actions/Firebase';

import * as FirestoreService from './FirebaseRealTimeDb';
import * as firebaseFunctions from '../../firebase/functions';
import Cookies from 'universal-cookie';
import { useLocation } from 'react-router-dom';
import moment from 'moment-timezone';
import AppleIcon from '@material-ui/icons/Apple';
import DiscordOauth2 from 'discord-oauth2';
import { StringFormat, getDownloadURL, ref as storageRef, uploadString} from 'firebase/storage';
import * as tradeIdeasApiService from '../../../services/rest/TradeIdeasApiService';

const crypto = require('crypto');

const MarketActionDbRef = collection(firestore, 'MarketActionDb');
const useStyles = makeStyles(theme => ({
  iconBtn: {
    '&:hover, &:focus': {
      color: theme.palette.primary.main,
    },
    [theme.breakpoints.down('xs')]: {
      padding: 6,
    },
  },
  button: {
    textTransform: "none",
    height: "50px",
    width: "240px"
  }
}));

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const SocialMediaIcons = ({ isSignup }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  let query = useQuery();
  const refCode = query.get('refCode');

  const signInUserWithGoogle = refCode => {
    dispatch(fetchStart());
    try {
      signInWithPopup(auth, googleAuthProvider)
        .then(async data => {
          dispatch(UpdateLoadSubscription(false));
          await storeExtraUserFields(dispatch, data, data.user.email, data.user.displayName, refCode);
        })
        .catch(error => {
          dispatch(fetchError(error.message));
        });
    } catch (error) {
      dispatch(fetchError(error.message));
    }
  };

  const signInUserWithApple = refCode => {
    dispatch(fetchStart());
    try {
      signInWithPopup(auth, appleAuthProvider)
        .then(async data => {
          dispatch(UpdateLoadSubscription(false));
          await storeExtraUserFields(dispatch, data, data.user.email, data.user.displayName, refCode);
        })
        .catch(error => {
          dispatch(fetchError(error.message));
        });
    } catch (error) {
      dispatch(fetchError(error.message));
    }
  };

  const signInUserWithDiscord = refCode => {
    dispatch(fetchStart());
    try {
      const oauth = new DiscordOauth2({
        clientId: process.env.REACT_APP_DISCORD_CLIENT_ID,
        redirectUri: window.location.origin + "/callback"
      });

      const url = oauth.generateAuthUrl({
        scope: ["identify", "email"],
        state: crypto.randomBytes(16).toString("hex"), // Be aware that randomBytes is sync if no callback is provided
      });

      window.open(url,'targetWindow','toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=600,height=900');
    } catch (error) {
      dispatch(fetchError(error.message));
    }
  };

  const signInUserWithGithub = () => {
    dispatch(fetchStart());
    try {
      signInWithPopup(auth, githubAuthProvider)
        .then(data => {
          dispatch(fetchSuccess());
          dispatch(setAuthUser(data.user));
        })
        .catch(error => {
          dispatch(fetchError(error.message));
        });
    } catch (error) {
      dispatch(fetchError(error.message));
    }
  };

  const signInUserWithFacebook = () => {
    dispatch(fetchStart());
    try {
      signInWithPopup(auth, facebookAuthProvider)
        .then(data => {
          dispatch(fetchSuccess());
          dispatch(setAuthUser(data.user));
        })
        .catch(error => {
          dispatch(fetchError(error.message));
        });
    } catch (error) {
      dispatch(fetchError(error.message));
    }
  };

  const signInUserWithTwitter = () => {
    dispatch(fetchStart());
    try {
      signInWithPopup(auth, twitterAuthProvider)
        .then(data => {
          dispatch(fetchSuccess());
          dispatch(setAuthUser(data.user));
        })
        .catch(error => {
          dispatch(fetchError(error.message));
        });
    } catch (error) {
      dispatch(fetchError(error.message));
    }
  };

  return (
    <Box display="flex" alignItems="center" flexDirection="column" style={{gap:"15px"}}>
      <GoogleButton
        type="dark"
        style={{ backgroundColor: '#6200EE' }}
        label={isSignup === true ? 'Signup with Google' : 'Signin with Google'}
        onClick={() => signInUserWithGoogle(refCode)}
      />
      <Button
        variant="contained"
        className={classes.button}
        startIcon={<AppleIcon />}
        onClick={() => signInUserWithApple(refCode)}
      >
        {isSignup === true ? 'Signup with Apple' : 'Signin with Apple'}
      </Button>
      <Button
       color="primary"
        variant="contained"
        className={classes.button}
        startIcon={<svg width="24" height="24" viewBox="0 0 256 293" className="svgIconSideBar makeStyles-iconRoot-61 Cmt-icon-root">
        <g>
            <path d="M226.011429,0 L29.9885714,0 C13.4582857,0 0,13.4582857 0,30.1348571 L0,227.913143 C0,244.589714 13.4582857,258.048 29.9885714,258.048 L195.876571,258.048 L188.123429,230.985143 L206.848,248.393143 L224.548571,264.777143 L256,292.571429 L256,30.1348571 C256,13.4582857 242.541714,0 226.011429,0 Z M169.545143,191.049143 C169.545143,191.049143 164.278857,184.758857 159.890286,179.2 C179.053714,173.787429 186.368,161.792 186.368,161.792 C180.370286,165.741714 174.665143,168.521143 169.545143,170.422857 C162.230857,173.494857 155.209143,175.542857 148.333714,176.713143 C134.290286,179.346286 121.417143,178.614857 110.445714,176.566857 C102.107429,174.957714 94.9394286,172.617143 88.9417143,170.276571 C85.5771429,168.96 81.92,167.350857 78.2628571,165.302857 C77.824,165.010286 77.3851429,164.864 76.9462857,164.571429 C76.6537143,164.425143 76.5074286,164.278857 76.3611429,164.132571 C73.728,162.669714 72.2651429,161.645714 72.2651429,161.645714 C72.2651429,161.645714 79.2868571,173.348571 97.8651429,178.907429 C93.4765714,184.466286 88.064,191.049143 88.064,191.049143 C55.7348571,190.025143 43.4468571,168.813714 43.4468571,168.813714 C43.4468571,121.709714 64.512,83.5291429 64.512,83.5291429 C85.5771429,67.7302857 105.618286,68.1691429 105.618286,68.1691429 L107.081143,69.9245714 C80.7497143,77.5314286 68.608,89.088 68.608,89.088 C68.608,89.088 71.8262857,87.3325714 77.2388571,84.8457143 C92.8914286,77.9702857 105.325714,76.0685714 110.445714,75.6297143 C111.323429,75.4834286 112.054857,75.3371429 112.932571,75.3371429 C121.856,74.1668571 131.949714,73.8742857 142.482286,75.0445714 C156.379429,76.6537143 171.300571,80.7497143 186.514286,89.088 C186.514286,89.088 174.957714,78.1165714 150.089143,70.5097143 L152.137143,68.1691429 C152.137143,68.1691429 172.178286,67.7302857 193.243429,83.5291429 C193.243429,83.5291429 214.308571,121.709714 214.308571,168.813714 C214.308571,168.813714 201.874286,190.025143 169.545143,191.049143 Z M101.522286,122.733714 C93.184,122.733714 86.6011429,130.048 86.6011429,138.971429 C86.6011429,147.894857 93.3302857,155.209143 101.522286,155.209143 C109.860571,155.209143 116.443429,147.894857 116.443429,138.971429 C116.589714,130.048 109.860571,122.733714 101.522286,122.733714 M154.916571,122.733714 C146.578286,122.733714 139.995429,130.048 139.995429,138.971429 C139.995429,147.894857 146.724571,155.209143 154.916571,155.209143 C163.254857,155.209143 169.837714,147.894857 169.837714,138.971429 C169.837714,130.048 163.254857,122.733714 154.916571,122.733714"></path>
        </g>
    </svg>}
        onClick={() => signInUserWithDiscord(refCode)}
      >
        {isSignup === true ? 'Signup with Discord' : 'Signin with Discord'}
      </Button>
      {/* <IconButton className={classes.iconBtn} onClick={signInUserWithFacebook}>
        <FacebookIcon />
      </IconButton>
      <IconButton className={classes.iconBtn} onClick={signInUserWithTwitter}>
        <TwitterIcon />
      </IconButton> */}
      {/* <IconButton className={classes.iconBtn} onClick={signInUserWithGithub}>
        <GitHubIcon />
      </IconButton> */}
    </Box>
  );
};

async function storeExtraUserFields(dispatch, authUser, email, name, referralCode) {
  await updateProfile(authUser.user, {
    displayName: name,
  });

  firebaseFunctions.callfunction(
    'registerFirebaseUser',
    {
      uid: authUser.user.uid,
      refCode: referralCode === null || referralCode === undefined ? '' : referralCode,
      createDate: moment().format('YYYY-MM-DD H:mm:ss'),
    },
    async res => {
      if (res.data.status === 1 || res.data.status === 3) {
        await FirestoreService.getUserExtraData(async doc => {
          var userDetails = {};
          var isAdmin = false;
          if (doc.exists()) {
            userDetails = doc.data();
          }

          var user = authUser.user;
          await FirestoreService.getIsAdmin(async doc => {
            if (doc.exists()) {
              isAdmin = doc.data().IsAdmin;
            }

            let tradeIdeasToken = await getTradeIdeasToken();

            dispatch(
              setAuthUser({
                uid: user.uid,
                displayName: user.displayName,
                email: user.email,
                photoURL: user.photoURL,
                token: user.refreshToken,
                phoneNumber: user.phoneNumber,
                userDetails: userDetails,
                isAdmin: isAdmin,
                tradeIdeasToken: tradeIdeasToken
              }),
            );

            dispatch(fetchSuccess());
          });
        });
      } else {
        dispatch(fetchError(res.data.msg));
      }
    },
  );

  const cookies = new Cookies();
  cookies.set('fromSignup', 'true', {
    path: '/',
    expires: new Date(new Date().setMinutes(new Date().getMinutes() + 5)),
  });
}

async function getTradeIdeasToken() {
  let tradeIdeasToken = '';
  try {
    let token = await getIdToken(auth.currentUser, true);
    let tokenData = await tradeIdeasApiService.PostAsync('/auth/loginWithToken', { token: token }, '');
    tradeIdeasToken = tokenData.data.token;
  }
  catch (err) {
    console.error(err);
  }
  return tradeIdeasToken;
}

function setUserAuthData(dispatch, data) {
  FirestoreService.getUserExtraData(async doc => {
    var user = data.user;

    try {
      await firebaseFunctions.callfunctionAsync('updateCustomClaims', {
        uid: user.uid,
      });
    } catch (err) {
      console.log(err);
    }

    var userDetails = {};
    var isAdmin = false;
    if (doc.exists()) {
      userDetails = doc.data();
    }

    var user = data.user;
    FirestoreService.getIsAdmin(async doc => {
      if (doc.exists()) {
        isAdmin = doc.data().IsAdmin;
      }

      dispatch(fetchSuccess());

      let tradeIdeasToken = await getTradeIdeasToken();

      dispatch(
        setAuthUser({
          uid: user.uid,
          displayName: user.displayName,
          email: user.email,
          photoURL: user.photoURL,
          token: user.refreshToken,
          phoneNumber: user.phoneNumber,
          userDetails: userDetails,
          isAdmin: isAdmin,
          tradeIdeasToken: tradeIdeasToken
        }),
      );
    });
  });
}

const Firebase = {
  onRegister: ({ name, email, password, roles, referralCode }) => {
    return dispatch => {
      dispatch(fetchStart());
      try {
        createUserWithEmailAndPassword(auth, email, password)
          .then(async authUser => {
            dispatch(UpdateLoadSubscription(false));
            await storeExtraUserFields(dispatch, authUser, email, name, referralCode);
          })
          .catch(error => {
            dispatch(fetchError(error.message));
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },

  onLogin: ({ email, password }) => {
    return dispatch => {
      try {
        dispatch(fetchStart());
        signInWithEmailAndPassword(auth, email, password)
          .then(async data => {
            dispatch(UpdateLoadSubscription(false));
            setUserAuthData(dispatch, data);
          })
          .catch(error => {
            dispatch(fetchError(error.message));
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },

  onImpersonate: ({ customToken }) => {
    return dispatch => {
      try {
        dispatch(fetchStart());
        signInWithCustomToken(auth, customToken)
          .then(data => {
            dispatch(UpdateLoadSubscription(false));
            setUserAuthData(dispatch, data);
          })
          .catch(error => {
            dispatch(fetchError(error.message));
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },

  onLogout: () => {
    return dispatch => {
      dispatch(fetchStart());
      try {
        signOut(auth)
          .then(data => {
            dispatch(fetchSuccess());
            dispatch({ type: 'LOG_OUT', payload: null });
            window.location.reload();
          })
          .catch(error => {
            dispatch(fetchError(error.message));
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },

  getAuthUser: () => {
    return dispatch => {
      dispatch(fetchStart());
      dispatch(updateLoadUser(false));
      try {
        onAuthStateChanged(auth, async authUser => {
          dispatch(fetchSuccess());
          if (authUser) {
            FirestoreService.getUserExtraData(async doc => {
              var userDetails = {};
              var isAdmin = false;
              if (doc.exists()) {
                userDetails = doc.data();
              }

              FirestoreService.getIsAdmin(async doc => {
                if (doc.exists()) {
                  isAdmin = doc.data().IsAdmin;
                }

                let tradeIdeasToken = await getTradeIdeasToken();

                dispatch(
                  setAuthUser({
                    uid: authUser.uid,
                    displayName: authUser.displayName,
                    email: authUser.email,
                    photoURL: authUser.photoURL,
                    token: authUser.refreshToken,
                    phoneNumber: authUser.phoneNumber,
                    userDetails: userDetails,
                    isAdmin: isAdmin,
                    tradeIdeasToken: tradeIdeasToken
                  }),
                );
              });
            });
          } else {
            dispatch(updateLoadUser(true));
            dispatch(UpdateLoadSubscription(true));
          }
        });
      } catch (error) {
        dispatch(updateLoadUser(true));
        dispatch(UpdateLoadSubscription(true));
        dispatch(fetchError(error.message));
      }
    };
  },

  onForgotPassword: ({ email }) => {
    return dispatch => {
      dispatch(fetchStart());
      try {
        sendPasswordResetEmail(auth, email)
          .then(response => {
            dispatch(fetchSuccess('A link to reset your password has been sent to your email!', '/signin'));
          })
          .catch(error => {
            dispatch(fetchError(error.message));
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  getSocialMediaIcons: isSignup => {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" style={{ marginBottom: '10px' }}>
        <SocialMediaIcons isSignup={isSignup} />
      </Box>
    );
  },
  updateUserDataOnSignUp: ({ traderType, experienceLevel, imageData }) => {
    return dispatch => {
      dispatch(fetchStart());
      try {
        if (auth.currentUser) {
          const userDataRef = doc(MarketActionDbRef, auth.currentUser.uid);
          return updateDoc(userDataRef, {
              userExperience: {
                traderType: traderType,
                experience: experienceLevel,
              },
              isSignUpComplete: true,
            })
            .then(() => {
              if (imageData.result === null) {
                dispatch(fetchSuccess());
                return;
              }

              var profilePictureStorageRef = storageRef(storage, '/' + auth.currentUser.uid + '/profilePictures/' + auth.currentUser.uid);
              
              uploadString(profilePictureStorageRef, imageData.result, StringFormat.DATA_URL).then(() => {
                getDownloadURL(profilePictureStorageRef)
                  .then(function(url) {
                    updateProfile(auth, { photoURL: url })
                      .then(function() {
                        dispatch(Firebase.getAuthUser());
                        dispatch(fetchSuccess());
                      })
                      .catch(function(err) {
                        dispatch(fetchError(err.message));
                      });
                  })
                  .catch(function(err) {
                    dispatch(fetchError(err.message));
                  });
              });
            })
            .catch(err => {
              dispatch(fetchError(err.message));
            });
        }
      } catch (err) {
        dispatch(fetchError(err.message));
      }
    };
  },
};

export default Firebase;
